<template>
    <div>
        <div class="ibox form"  id="containerId">
            <input type="text" hidden id="operations-id-to-delete-lock" :value="allOperationsId">
            <div class="ibox-title ibox-grey">
                <h4>
                    {{ header }}
                </h4>
                <button-open-help-modal :helpName="help.mainCurrentHelpLocalization"/>
            </div>
            <div class="ibox-content">
                <div class="row">
                    <div class="col-md-10">
                        <h4>
                            {{ source.name }} | <small>{{ source.localized_payment_type }} | {{ source.currency }}</small>
                        </h4>
                    </div>
                </div>
                <div
                    v-if="group.other_payments == 0 && actionType !== 'create' && actionType !== 'create?'"
                    class="form-group row m-b-sm align-items-center"
                >
                    <div class="col-md-2" :class="{ 'has-error': hasError('groupState.name') }">
                        <label>{{ __('payment_source_name_short') }}*</label>
                        <div class="input-group">
                            <span
                                class="input-group-addon"
                                style="font-size: 12px; padding-top: 8px;"
                            >
                                {{ __('operation_group_show_' + typeName) }}
                            </span>
                            <input
                                v-model="group.name"
                                type="text"
                                name="group[name]"
                                class="form-control group[name]"
                                :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                                :readonly="(method === 'edit' && group != null  && lastGroup != null && lastGroup.id !== group.id) || disabled || group.status=='closed'"
                                @change="updateGroupState(group.date_to, group.name)"
                            >
                        </div>
                        <span class="help-block text-danger" v-show="hasError('groupState.name')">
                            {{ hasError('groupState.name') ? formErrors['groupState.name'][0] : '' }}
                        </span>
                    </div>
                    <div class="col-md-2" :class="{ 'has-error': hasError('groupState.date_from') }">
                        <label>{{ __('interval_from_day') }}*</label>
                        <datepicker
                            v-model="group.date_from"
                            name="date_from" id="date_from_id"
                            :options="datePickerDateFromOptions"
                        >
                        </datepicker>
                        <span class="help-block text-danger" v-show="hasError('groupState.date_from')">
                            {{ hasError('groupState.date_from') ? formErrors['groupState.date_from'][0] : '' }}
                        </span>
                    </div>
                    <div class="col-md-2" :class="{ 'has-error': hasError('groupState.date_to') }">
                        <label>{{ __('to_day') }}*</label>
                        <datepicker
                            name="date_to"
                            :value="group.date_to"
                            :options="datePickerDateToOptions"
                            :min_date="getDateFrom()"
                            id="date_picker_date_to"
                            @change="dateToChangeHandler"
                        >
                        </datepicker>
                        <span class="help-block text-danger" v-show="hasError('groupState.date_to')">
                            {{ hasError('groupState.date_to') ? formErrors['groupState.date_to'][0] : '' }}
                        </span>
                    </div>
                    <div class="col-md-4"></div>
                    <div class="col-md-2 text-right">
                        <h5>{{ __('starting_balance') }}:</h5>
                        <strong>
                            <h4>
                                {{ group.formatted_starting_balance }}
                                {{ source.currency ? source.currency : '-' }}
                            </h4>
                        </strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="ibox form" v-if="group.other_payments == 0 && group.other_payments == 0 && actionType !== 'create' && actionType !== 'create?'">
            <div class="ibox-title ibox-grey">
                <h4>{{ __('operation_group_operations_' + typeName) }}</h4>
                <button-open-help-modal :helpName="help.helpOperationGroupOperations"/>
            </div>
            <div class="ibox-content">
                <div class="operations">
                    <operation-form
                        v-for="(operation, index) in operations"
                        ref="operation"
                        @setStorageData="setStorageData"
                        @move="onMove"
                        @moveToGroup="onMoveToGroup"
                        @amountHasChanged="onAmountHasChanged"
                        @checkNextOperations="onCheckNextOperations"
                        :group-name="'operations'"
                        :operation="operation"
                        :updated-at="updated_at"
                        :index="index"
                        :permission-access="perminssionAccess"
                        :key="'operations_' + operation.id"
                        :type-name="typeName"
                        :disabled="disabled"
                        :move-down-enabled="operations.hasOwnProperty(index+1) && operations[index].date === operations[index+1].date"
                        :move-up-enabled="operations.hasOwnProperty(index-1) && operations[index].date === operations[index-1].date"
                        :method="method"
                        :action-type="actionType"
                        :departments="departments"
                        :date-to="group.date_to"
                        :open-modal-operation-id="openModalOperationId"
                        :errors="formErrors"
                        :group-name-to-return="group.name"
                        @reloadOperations="reloadOperations"
                        :helpName='"EZN-001"'
                        :has-access="hasAccess"
                        :has-access-default="hasAccessDefault"
                        :has-access-pl="hasAccessPl"
                        :has-access-other-department="hasAccessOtherDepartment"
                        :allow-invoice-for-bill-without-contractor="allowInvoiceForBillWithoutContractor"
                    />
                </div>
                <div class="form-group row m-b-sm" v-show="!disabled && !(method === 'edit' && !isLastGroup) && this.group.status != 'closed'" >
                    <div class="col-md-3">
                        <div class="input-group">
                            <input
                                v-model="operationsToAdd"
                                type="number"
                                id="template-count"
                                class="form-control"
                                style="max-width: 50px;"
                            >
                            <button
                                type="button"
                                class="btn btn-primary btn-sm m-l-xs"
                                @click="addOperationHandler('group')"
                            >
                                <i class="fa fa-plus"></i> {{ __('add_operation') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ibox" v-show="!disabled" v-if="actionType=== 'createGroup' || isLastGroup || (actionType === 'editGroup' && groupStatus === 'closed') || (actionType === 'edit' && groupStatus === 'closed')">
            <div class="ibox-content">
                <div class="row align-items-center">
                    <div class="col-sm-10">
                        <a
                            class="btn btn-white btn-sm"
                            data-toggle="tooltip"
                            data-placement="top"
                            @click="clearLocalStorage"
                        >
                            {{ __('return') }}
                        </a>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            v-if="method !== 'show' && source.payment_type_name === 'cash_register'"
                            :disabled="submitting"
                            @click="submitGroupForm"
                        >
                            {{ __('save_cash_register') }}
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" @click="submitGroupForm"
                                :disabled="submitting"
                                v-else-if="method !== 'show' && ((group !== null && group.other_payments === 0) || group === null) &&
                            (source.payment_type_name === 'credit_card' || source.payment_type_name === 'another_payment_source' ||
                            source.payment_type_name === 'bank_account')">
                            {{getSaveNameByPaymentType(source.payment_type_name) }}
                        </button>
                        <button
                            v-else
                            type="button"
                            class="btn btn-primary btn-sm"
                            :disabled="submitting"
                            @click="submitGroupForm"
                        >
                            {{ getSaveNameByPaymentType(source.payment_type_name) }}
                        </button>
                    </div>
                    <div class="col-md-2 text-right" v-if="group.other_payments === 0">
                        <h5>{{ __('ending_balance') }}:</h5>
                        <strong>
                            <h4>
                                <span id="ending_balance_text">{{ group.formatted_ending_balance }}</span>
                                {{ source.currency ? source.currency : '-' }}
                            </h4>
                        </strong>
                    </div>
                </div>
            </div>
        </div>
        <div

            class="ibox form"
            v-if="(group.other_payments == 1 || group.other_payments == 0) && group.status !== 'closed'"
        >
            <div class="ibox-title ibox-grey">
                <h4>{{ __('other_operations') }}</h4>
                <button-open-help-modal :helpName="help.helpOtherOperations"/>
            </div>
            <div class="ibox-content">
                <div class="other-operations">
                    <operation-form
                        v-for="(operation, index) in otherOperations"
                        @move="onMove"
                        @setStorageData="setStorageData"
                        @moveToGroup="onMoveToGroup"
                        @amountHasChanged="onAmountHasChanged"
                        :group-name="'otherOperations'"
                        :operation="operation"
                        :updated-at="updated_at"
                        :index="index"
                        :departments="departments"
                        :permission-access="perminssionAccess"
                        :key="'otherOperations_' + operation.id"
                        :type-name="typeName"
                        :disabled="disabled"
                        :method="method"
                        :action-type="actionType"
                        :date-to="group.date_to"
                        :open-modal-operation-id="openModalOperationId"
                        :move-down-enabled="otherOperations.hasOwnProperty(index+1) && otherOperations[index].date === otherOperations[index+1].date"
                        :move-up-enabled="otherOperations.hasOwnProperty(index-1) && otherOperations[index].date === otherOperations[index-1].date"
                        :errors="formErrors"
                        @reloadOperations="reloadOperations"
                        :group-name-to-return="group.name"
                        :has-access="hasAccess"
                        :has-access-default="hasAccessDefault"
                        :has-access-pl="hasAccessPl"
                        :has-access-other-department="hasAccessOtherDepartment"
                        :allow-invoice-for-bill-without-contractor="allowInvoiceForBillWithoutContractor"
                    />
                </div>
                <div v-if="((group.other_payments === 1 && getPermission('adding_other_operations')) ||
                               (group.other_payments != 1 && getPermission('adding_operation_in_cash_register')) )" class="form-group row m-b-sm" v-show="!disabled && !(isLastGroup) && actionType !== 'createGroup' && actionType != 'createGroup?'">
                <div class="col-md-3">
                    <div class="input-group">
                        <input
                            v-model="operationsToAdd"
                            type="number"
                            class="form-control"
                            style="max-width: 50px;"
                        >
                        <button
                            type="button"
                            class="btn btn-primary btn-sm m-l-xs"
                            @click="addOperationHandler('other')"
                        >
                            <i class="fa fa-plus"></i> {{ __('add_operation') }}
                        </button>
                    </div>
                </div>
            </div>
            </div>

        </div>
        <div class="ibox" v-show="!disabled" v-if="!(actionType === 'edit' && group.other_payments === 0) && actionType!=='createGroup' && actionType!=='editGroup' || (actionType==='editGroup' && group.other_payments === 1)">
            <div class="ibox-content">
                <div class="row align-items-center">
                    <div class="col-sm-10">
                        <a
                            class="btn btn-white btn-sm"
                            data-toggle="tooltip"
                            data-placement="top"
                            @click="clearLocalStorage"
                        >
                            {{ __('return') }}
                        </a>
                        <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            v-if="method !== 'show' && ((group !== null && group.other_payments === 0) || group === null) &&
                            (source.payment_type_name === 'cash_register' || source.payment_type_name === 'safe') && group.other_payments == 0 && actionType !== 'create' && actionType !== 'create?'"
                            :disabled="submitting"
                            @click="submitGroupForm"
                        >
                            {{ __('save_cash_register') }}
                        </button>
                        <button type="button" class="btn btn-primary btn-sm" @click="submitGroupForm"
                                :disabled="submitting"
                                v-else-if="method !== 'show' && ((group !== null && group.other_payments === 0) || group === null) &&
                            (source.payment_type_name === 'credit_card' || source.payment_type_name === 'another_payment_source' ||
                            source.payment_type_name === 'bank_account') && group.other_payments == 0 && actionType !== 'create' && actionType !== 'create?'">
                            {{ __('save_statement') }}
                        </button>
                        <button
                            v-else
                            type="button"
                            class="btn btn-primary btn-sm"
                            :disabled="submitting"
                            @click="submitGroupForm"
                        >
                            {{ __('save_operations') }}
                        </button>
                    </div>
                    <div class="col-md-2 text-right" v-if="group.other_payments === 0">
                        <h5>{{ __('ending_balance') }}:</h5>
                        <strong>
                            <h4>
                                <span id="ending_balance_text">{{ group.formatted_ending_balance }}</span>
                                {{ source.currency ? source.currency : '-' }}
                            </h4>
                        </strong>
                    </div>
                </div>
            </div>
        </div>
        <help-modal/>
    </div>
</template>

<script>
import actions from './../../vuex/action_types.js'
import mutations from './../../vuex/mutation_types.js'
import OperationForm from "../../components/Payments/OperationForm";
import store from '../../vuex/store';
import {Money} from "../../services/Money";
import $ from "jquery";
import events from "../../services/Events";
import HelpModal from '../../components/help/HelpModal.vue';
import permissions from '../../services/Permissions.js';
import ButtonOpenHelpModal from '../../components/help/ButtonOpenHelpModal.vue'

export default {
    name: "GroupForm",
    components: {OperationForm, HelpModal, ButtonOpenHelpModal},
    data: function () {
        return {
            refreshAfterDateChange: true,
            money: new Money(),
            formErrors: {},
            operationsToAdd: 1,
            newOperationId: 0,
            submitting: false,
            ids: [],
            clear: true,
            updated_at: Date.now()
        }
    },
    props: {
        perminssionAccess: [],
        groupId: {
            type: String,
            required: true,
        },
        groupStatus: {
            type: String,
            required: false,
        },
        allowInvoiceForBillWithoutContractor: {
            type: Number,
            required: false,
            default: 0,
        },
        method: {
            type: String,
            required: true,
        },
        typeName: {
            type: String,
            required: true,
        },
        groupDateFrom: {
            type: String,
            required: false,
        },
        paymentSourceId: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
            default: false,
        },
        hasAccess: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessDefault: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessPl: {
            type: Number,
            required: false,
            default: 0,
        },
        hasAccessOtherDepartment: {
            type: Number,
            required: false,
            default: 0,
        },
        openModalOperationId: {
            type: String,
            required: false,
        },
        actionType: {
            type: String,
            required: true,
        },
        header: {
            type: String,
            required: true,
        },
        returnUrl: {
            type: String,
            required: true,
        },
        departments: {
            type: Array,
            required: false,
        },
        clearStorage: {
            type: Number,
            required: false,
            default: 1,
        },
        createdOperation:{
            type: Object,
            required: false,
            default: () => {
            },
        }
    },
    computed: {
        group: function () {
            return this.$store.getters.getGroupData
        },
        operations: function () {
            return this.$store.getters.getOperations
        },
        otherOperations: function () {
            return this.$store.getters.getOtherOperations
        },
        allOperationsId: function (){
            this.ids = [];
            this.operations.forEach(operation=>{
                if(operation !== undefined && operation != null){
                    if(operation.id > 0){
                        this.ids.push(operation.id)
                    }
                }
            });
            this.otherOperations.forEach(operation=>{
                if(operation.id > 0){
                    this.ids.push(operation.id)
                }
            });
            return this.ids;
        },
        lastGroup: function () {
            return this.$store.getters.getLastGroupData
        },
        source: function () {
            return this.$store.getters.getSource
        },
        isLastGroup: function () {
            return (this.lastGroup !== null && this.lastGroup.id === this.group.id)
        },
        datePickerDateFromOptions: function () {
            return {
                startView: 0,
                todayBtn: this.lastGroup === null || this.group.id === 0 || this.isLastGroup ? 'linked' : false,
                keyboardNavigation: false,
                forceParse: false,
                autoclose: true,
                format: "yyyy-mm-dd",
                todayHighlight: true,
                orientation: 'auto',
                disabled: true
            }
        },
        datePickerDateToOptions: function () {
            return {
                startView: 0,
                todayBtn: this.lastGroup === null || this.group.id === 0 || this.isLastGroup ? 'linked' : false,
                keyboardNavigation: false,
                forceParse: false,
                autoclose: true,
                format: "yyyy-mm-dd",
                todayHighlight: true,
                orientation: 'auto',
                disabled: (this.method === 'edit' && !this.isLastGroup) || this.disabled || this.group.status == 'closed',
                startDate: this.getDateFrom(),
                minDate: this.getDateFrom(),
            }
        },
        dateToInitDate: function () {
            return moment(this.group.date_from).isBefore(moment()) && this.actionType === 'createGroup' ? moment().format('YYYY-MM-DD') : this.group.date_to
        },
        paymentSource: function () {
            return this.$store.getters.getSource;
        },
        help: function () {
            if (this.actionType == "createGroup") {
                var localization = "";
                if (this.typeName != 'cash_register')
                    localization = 'EZK';

                return {
                    "mainCurrentHelpLocalization": localization + "-001",
                    "helpOperationGroupOperations": localization + "-002",
                    "helpOtherOperations": localization + "-003"
                }
            }
            if (this.actionType == "create") {
                return {
                    "mainCurrentHelpLocalization": "EZJ-001",
                    "helpOperationGroupOperations": null,
                    "helpOtherOperations": "EZJ-002"
                }
            }

            return "";

        }
    },
    methods: {
        setStorageData(){
          this.clear = false;
        },
        getSaveNameByPaymentType(paymentType){
            const self = this;
            switch (paymentType){
                case 'another_payment_source':
                    return self.__('save_group_statement');
                case 'safe':
                    return self.__('save_cash_raport');
                default:
                    return self.__('save_statement');
            }
        },
        getPermission: function(permission) {
                return permissions.getPermission(this.perminssionAccess, permission);
        },
        count: function (list) {
            return list.length;
        },
        hasError: function (field) {
            return !['', null, undefined].includes(this.formErrors)
                && this.formErrors.hasOwnProperty(field)
                && Array.isArray(this.formErrors[field])
                && this.formErrors[field].length >= 1;

        },
        prepareNewOperationDate: function () {
            let newOperationDate = '';
            if(this.actionType=== 'createGroup' || this.actionType=== 'createGroup?') {
                if (this.operations.length > 0) {
                    newOperationDate = this.operations[this.operations.length - 1].date;
                } else if (this.operations.length === 0) {
                    newOperationDate = this.group.date_from;
                }
            }
            else if ((this.actionType=== 'create' || this.actionType === 'create?') || (this.actionType==='editGroup' && this.group.other_payments === 1)){
                if (this.otherOperations.length > 0) {
                    newOperationDate = this.otherOperations[this.otherOperations.length - 1].date;
                } else if (this.operations.length === 0) {
                    newOperationDate = this.group.date_from;
                }
            }
            else if((this.actionType=== 'editGroup' || this.actionType === "edit") && this.group.status === 'opened' ){
                if (this.operations.length > 0) {
                    newOperationDate = this.operations[this.operations.length - 1].date;
                } else if (this.operations.length === 0) {
                    newOperationDate = this.group.date_from;
                }
            }
            else if(this.actionType === "edit" && this.group.status === 'other_operation'){
                newOperationDate = this.otherOperations[this.otherOperations.length - 1].date;
            }
            return moment(newOperationDate).format('YYYY-MM-DD')

        },
        updateGroupState: function (date_to = null, group_name = null) {
            this.$store.commit(mutations.UPDATE_GROUP_STATE, {
                'dateTo': date_to ?? this.group.date_to,
                'name': group_name ?? this.group.name
            });
        },
        addOperationHandler: function (name) {
            let newOperationDate = this.prepareNewOperationDate();
            if((this.actionType === 'createGroup' || this.actionType === 'createGroup?') && name === 'group' || this.actionType === 'editGroup' && name === 'group' || this.actionType==='edit' && name === 'group'){
                this.newOperationId = this.operations.filter(o=>{
                    return o.id < 0;
                }).length * -1;
                for (let i = 0; i < this.operationsToAdd; i++) {
                    this.newOperationId = this.newOperationId - 1;
                    this.$store.commit(mutations.ADD_OPERATION_TO_GROUP, {
                        'id': this.newOperationId,
                        'paymentSourceId': this.source.id,
                        'date': newOperationDate,
                        'currency': this.source.currency,
                        'currency_is_default': this.source.currency_is_default,
                    });
                }
            }
            else{
                this.newOperationId = this.otherOperations.filter(o=>{
                    return o.id < 0;
                }).length * -1;
                for (let i = 0; i < this.operationsToAdd; i++) {
                    this.newOperationId = this.newOperationId - 1;
                    this.$store.commit(mutations.ADD_OPERATION, {
                        'id': this.newOperationId,
                        'paymentSourceId': this.source.id,
                        'date': newOperationDate,
                        'currency': this.source.currency,
                        'currency_is_default': this.source.currency_is_default,
                    });
                }
            }

        },
        moveToOtherOperations: function (groupDateTo) {
            const self = this;
            let operations2 = [...this.operations]
            operations2.forEach((operation, index) => {
                if(operation !== undefined){
                    let operationDate = moment(operation.date)
                    if (operationDate.isAfter(groupDateTo)) {
                        store.commit(mutations.EXCHANGE_ELEMENTS, {
                            destinationGroup: 'otherOperations',
                            sourceIndex: operation.id
                        });
                        store.commit(mutations.SORT_GROUPS);
                    }
                }
            })
        },
        moveToOperations: function (groupDateTo) {
            let otherOperations2 = [...this.otherOperations]
            otherOperations2.forEach((operation, index) => {
                if(operation !== undefined){
                    let operationDate = moment(operation.date)
                    if (!operationDate.isAfter(groupDateTo)) {
                        store.commit(mutations.EXCHANGE_ELEMENTS, {
                            destinationGroup: 'operations',
                            sourceIndex: operation.id
                        });
                        store.commit(mutations.SORT_GROUPS);
                    }
                }

            });
        },
        dateToChangeHandler: function (newDate) {

            if(newDate < this.group.date_from){
                this.group.date_to = this.group.date_from;
                newDate = this.group.date_from;

            }
            let groupDateTo = moment(newDate)
            this.updateGroupState(newDate);
            this.moveToOperations(groupDateTo);
            this.moveToOtherOperations(groupDateTo);
            this.calculateBalance();

            $('#date_picker_date_to').find('input[name="date_to"]').val(newDate)
        },
        onMove: function (data) {
            if (data.group === 'operations') {
                this.operations.move(data.from, data.to);
            } else {
                this.otherOperations.move(data.from, data.to);
            }
            this.calculateBalance();
        },
        onMoveToGroup: function (params) {
            store.commit(mutations.EXCHANGE_ELEMENTS, {
                destinationGroup: params.destinationGroup,
                sourceIndex: params.sourceIndex
            });
            store.commit(mutations.SORT_GROUPS);
            this.calculateBalance();
        },
        calculateBalance: function () {
            this.calculateBalanceInGroup();
            this.calculateOtherOperationsBalance();
        },
        calculateOperationBalance: function (balanceAfterOperation, operation) {
            balanceAfterOperation += this.money.toFloat(operation.formatted_amount);
            operation.formatted_balance_after_operation = this.money.localize(balanceAfterOperation);
            return balanceAfterOperation;
        },
        calculateGroupEndingBalance: function (self, balanceAfterOperation) {
            self.group.formatted_ending_balance = self.money.localize(balanceAfterOperation);
        },
        calculateBalanceInGroup: function () {
            let self = this;
            let balanceAfterOperation = self.money.toFloat(self.group.formatted_starting_balance);
            $.each(this.operations, function (index, operation) {
                if (operation) {
                    self.updated_at = Date.now();
                    balanceAfterOperation = self.calculateOperationBalance(balanceAfterOperation, operation);
                }
            });
            this.calculateGroupEndingBalance(self, balanceAfterOperation);
        },
        calculateOtherOperationsBalance: function () {
            let self = this;
            let balanceAfterOperation = self.money.toFloat(self.group.formatted_ending_balance);
            $.each(this.otherOperations, function (index, operation) {
                if (operation) {
                    balanceAfterOperation = self.calculateOperationBalance(balanceAfterOperation, operation)
                    self.updated_at = Date.now();
                };

            })
        },
        onAmountHasChanged: function () {
            this.calculateBalance();
        },
        refreshTitleForAllOperations:function (exclude){
            this.$store.dispatch(actions.REFRESH_TITLE_FOR_OPERATIONS, {
               ids: this.allOperationsId,
               exclude:exclude
            })
        },

        reloadOperations: function (id, index, date, title, source_transfer_amount = null, original_index = false, createdOperationOb = null){
            const self = this;
            const operationsCopy = [...this.operations]
            const otherOperationsCopy = [...this.otherOperations]
            let current_date_to = moment(this.group.date_to).format('YYYY-MM-DD');
            let operation_date = moment(date).format('YYYY-MM-DD');
            let old_operation_date =  moment(window.localStorage.getItem('operation_date')).format('YYYY-MM-DD')
            let current_name = this.group.name ?? ''
            this.$store.dispatch(actions.PREPARE_GROUP_DATA, {
                id: this.group.id,
                source: this.group.payment_source_id,
                actionType: this.actionType,
                return: window.location.href,
                operations: this.operations.map(function(operation) {
                    return operation.id;
                }),
                otherOperations: this.otherOperations.map(function(operation) {
                    return operation.id;
                }),
                created_operation: id,
            }).then(() => {
                this.$store.commit(mutations.UPDATE_GROUP_DATA_WITH_EXISTING_OPERATION, {
                    'operations': operationsCopy,
                    'other_operations':otherOperationsCopy,
                    "index": index,
                    "id": id,
                    "all_operations_count": self.allOperationsId.length > 0 ? self.allOperationsId.length-1 : 0,
                    "type": ((operation_date <= current_date_to) && self.group.other_payments !== 1)  ? 'operations' : 'otherOperations'
                })
                this.$store.commit(mutations.UPDATE_GROUP_STATE, {
                    'dateTo': current_date_to,
                    'name': current_name
                });
                if(operation_date <= current_date_to && self.actionType !== 'create' && self.group.other_payments !== 1){
                    let newIndex = '';
                    if(old_operation_date <= current_date_to && operation_date <= current_date_to){
                        if(original_index){
                            newIndex = index
                        }
                    }

                    else if(old_operation_date > current_date_to && operation_date <= current_date_to){

                        self.$store.commit(mutations.DELETE_OPERATION, {
                            'groupName': 'other_operations',
                            'index': index
                        });
                    }
                    if(createdOperationOb !== null){
                        if(newIndex == ''){
                            newIndex = self.operations.findIndex(operation => {
                                return operation.id == original_index;
                            });
                        }
                        self.operations[newIndex] = createdOperationOb
                        self.operations[newIndex].title = title
                    }
                    else{
                        newIndex = self.operations.findIndex(operation => {
                            return operation.id == original_index;
                        });
                        self.operations[newIndex].id = id;
                        self.operations[newIndex].title = title;
                    }

                    if(source_transfer_amount !== null){
                        self.operations[newIndex].amount = source_transfer_amount;
                        self.operations[newIndex].formatted_amount = self.money.localize(source_transfer_amount);
                    }

                }else{
                    let newIndex = '';
                    if(original_index && operation_date >= current_date_to && old_operation_date >= current_date_to){
                        newIndex = self.otherOperations.findIndex(function (operation){
                            return operation.id === index
                        })
                        if(old_operation_date <= current_date_to){
                            self.$store.commit(mutations.DELETE_OPERATION, {
                                'groupName': 'operations',
                                'index': index
                            });
                        }
                    }
                    else{
                        if(original_index && operation_date >= current_date_to )
                        {
                            if(self.otherOperations.length == 0){
                                newIndex = 0;
                            }
                            else{
                                if(self.otherOperations.length > 0){
                                    newIndex = self.otherOperations.length
                                }
                            }
                            self.$store.commit(mutations.DELETE_OPERATION, {
                                'groupName': 'operations',
                                'index': index
                            });
                        }
                        else{
                            newIndex = self.otherOperations.findIndex(function (operation){
                                return operation.id === index
                            })
                        }

                    }

                    if(newIndex < 0) {
                        newIndex = self.otherOperations.findIndex(function (operation){
                            return operation.id === newIndex
                        })
                    }
                    if(self.otherOperations[newIndex] == undefined){
                        newIndex = self.otherOperations.findIndex(function (operation){
                            return operation.id === newIndex;
                        });
                    }
                    if(self.otherOperations[newIndex] == undefined){
                       if(self.otherOperations[index]){
                           newIndex = index
                       }
                    }
                    self.otherOperations[newIndex].id = id;
                    self.otherOperations[newIndex].title = title;
                    self.otherOperations[newIndex].date = date;
                    if(source_transfer_amount !== null){
                        self.otherOperations[newIndex].amount = source_transfer_amount;
                        self.otherOperations[newIndex].formatted_amount = self.money.localize(source_transfer_amount);
                    }
                    if(createdOperationOb !== null){
                        self.otherOperations[newIndex] = createdOperationOb
                        self.otherOperations[newIndex].amount  = createdOperationOb.amount;
                        self.otherOperations[newIndex].title = title;
                        self.otherOperations[newIndex].formatted_amount = createdOperationOb.formatted_amount;
                        if(createdOperationOb.contractor_id){
                            self.otherOperations[newIndex].contractor_id = createdOperationOb.contractor_id;
                        }
                        self.otherOperations[newIndex].formatted_balance_after_operation = createdOperationOb.formatted_balance_after_operation;
                        self.otherOperations[newIndex].prevalidate_url = createdOperationOb.prevalidate_url
                        self.otherOperations[newIndex].destroy_url = createdOperationOb.destroy_url
                    }


                }
                toggleLoader(false);

                if(this.group.other_payments != 1){
                    this.moveToOperations(current_date_to);
                    this.moveToOtherOperations(current_date_to);
                }
                else{
                    this.moveToOtherOperations(current_date_to);
                }
                this.moveToOtherOperations(current_date_to);
                store.commit(mutations.SORT_GROUPS);
                if(this.typeName !== "cash_register"){
                    this.refreshTitleForAllOperations(id);
                }
                this.calculateBalance()
            })
        },
        changeNextNotZeroOperationsFormDate: function (data) {
            let operationForms = this.$refs.operation.slice(data.startIndex, data.lastIndex + 1)
            operationForms.forEach(operationForm => {
                operationForm.setDateValueWithoutChangeEvent(data.newDate);
            })
        },
        changeNextNotZeroOperationsObjectDate: function (data) {
            let operations = this.operations.slice(data.startIndex, data.lastIndex + 1)
            let stop = false;
            operations.forEach(operation => {
                if(operation.formatted_amount !== '0,00'){
                    stop = true;
                }
                if(!stop){
                    operation.date = data.newDate
                }
            });
        },
        onCheckNextOperations: function (data) {
            if (data.useForms) {
                this.changeNextNotZeroOperationsFormDate(data);
            } else {
                this.changeNextNotZeroOperationsObjectDate(data);
            }
        },
        submitGroupForm: function () {
            const self = this;
            this.submitting = true;
            toggleLoader()
            this.$store.dispatch(actions.SUBMIT_GROUP_FORM, {
                group_id: self.group.id,
                action_type: self.actionType,
                operations: self.operations,
                other_operations: self.otherOperations
            }).then(response =>{
                if($('#make-lock-request').val() == 1) {
                    doAjax('/user-active-routes/destroy-temp-lock', {route:$('#current-route-to-lock').val(), url:$('#current-url-to-lock').val()} ).then(()=>{
                        toastr['success'](self.__(response.data.notification.message)).css('border', '0px')
                        window.localStorage.clear();
                        window.location.href = self.returnUrl;
                    })
                }
                else{
                    toastr['success'](self.__(response.data.notification.message)).css('border', '0px')
                    window.localStorage.clear();
                    window.location.href = self.returnUrl;
                }


            }).catch(error => {
                console.log('errors: ', error.response.data.errors);
                this.formErrors = error.response.data.errors;
                window.localStorage.clear();
                this.submitting = false;
                toggleLoader(false)
            });
        },
        clearLocalStorage: function () {
            const _this = this;
            if($('#make-lock-request').val() == 1) {
                doAjax('/user-active-routes/destroy-temp-lock', {route:$('#current-route-to-lock').val(), url:$('#current-url-to-lock').val()} ).then(()=>{
                    window.location.href = _this.returnUrl;
                })
            }
            else{
                window.location.href = _this.returnUrl;
            }

        },
        preventNonNumbers: function ($event) {
            let allowed = [
                'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0',
                'Comma', 'Minus',
                'Tab', 'Delete', 'Insert', 'ArrowLeft', 'ArrowRight', 'Escape', 'Backspace', 'F5', 'Enter',
                'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4', 'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9',
                'NumpadComma', 'NumpadDecimal', 'NumpadSubtract', 'NumpadEnter'

            ];
            if (!allowed.includes($event.code)) {
                console.log($event.code);
                $event.preventDefault();
            }
        },
        getDateFrom: function () {
            if (this.actionType === 'create' || this.group.other_payments === 1) {
                if (!['', null, undefined].includes(this.lastGroup)) {
                    return moment(this.lastGroup.date_to).add(1, 'days').format('YYYY-MM-DD')
                } else {
                    return moment(this.paymentSource.for_day).add(1, 'days').format('YYYY-MM-DD')
                }
            } else {
                return moment(this.groupDateFrom).format('YYYY-MM-DD');
            }
        },
        handleUpdateBalanceAfterAllocation(data) {
            this.$store.commit(mutations.DYNAMIC_UPDATE_DOCUMENT_BALANCE, data);
        },
        destroyOperationAfterDocumentStatusChangeToRejected(operationID){

            const self = this;
            var index = self.otherOperations.findIndex(x => x.id == operationID);
            var name = 'other_operations';
            if(index < 0){
                index = self.operations.findIndex(x => x.id == operationID);
                name = 'operations'
            }
            if(index > 0){
                self.$store.commit(mutations.DELETE_OPERATION, {
                    'groupName': name,
                    'index': index
                });
            }
        },
        destroyOperationIfBackFromDocuments: function () {
            const self = this;
            if (window.localStorage.getItem('destroy_operation') == "true") {
                let index = window.localStorage.getItem('index');
                let hiddenGroup = window.localStorage.getItem('group_hidden_name');
                if (hiddenGroup && hiddenGroup != '') {
                    if (hiddenGroup == 'other_payments') {
                        self.$store.commit(mutations.DELETE_OPERATION, {
                            'groupName': 'other_operations',
                            'index': index
                        });
                    } else {
                        self.$store.commit(mutations.DELETE_OPERATION, {
                            'groupName': 'operations',
                            'index': index
                        });
                    }
                    window.localStorage.setItem('destroy_operation', '')
                    window.localStorage.setItem('group_hidden_name', '')
                }
            }
        }
    },
    mounted: function () {
        toggleLoader()
        const self = this;
        self.destroyOperationIfBackFromDocuments()
        setCheckUnsavedChangesHandler()
        const groupName = window.localStorage.getItem('groupName');
        const group_name = window.localStorage.getItem('group_name');
        const group_date_to = window.localStorage.getItem('group_date_to');
        if (![null, undefined, ''].includes(group_name) || ![null, undefined, ''].includes(group_date_to)) {

            this.$store.commit(mutations.UPDATE_GROUP_STATE, {
                'dateTo': group_date_to,
                'name': group_name
            });
            if(this.createdOperation !== undefined){
                this.reloadOperations(this.createdOperation.id, window.localStorage.getItem('index'), this.createdOperation.date, this.createdOperation.title, null ,true, this.createdOperation)
            }
        }


        if (![null, undefined, ''].includes(groupName)) {
            const urlParams = new URLSearchParams(window.location.search);
            if(urlParams.get('contractor_id')){
                if (groupName === 'operations') {
                    this.operations[window.localStorage.getItem('index')].contractor_id = urlParams.get('contractor_id');
                } else {
                    this.otherOperations[window.localStorage.getItem('index')].contractor_id = urlParams.get('contractor_id');
                }
                events.$emit('contractorAdded', {
                    groupName: window.localStorage.getItem('groupName'),
                    index: window.localStorage.getItem('index'),
                    contractorId: urlParams.get('contractor_id')
                });
            }
            toggleLoader(false)
        } else {
            toggleLoader()
            this.$store.dispatch(actions.PREPARE_GROUP_DATA, {
                id: this.groupId,
                source: this.paymentSourceId,
                actionType: this.actionType,
                return: window.location.href
            }).then(() => {
                this.group.date_to = this.dateToInitDate;
                if(this.openModalOperationId == null || this.openModalOperationId == '' || this.openModalOperationId == undefined){
                    toggleLoader(false)
                }
                toggleLoader(false)
            });
        }


        this.$store.dispatch(actions.FETCH_SELECT2_CONTRACTORS_LIST);
        window.onbeforeunload = function (e) {
            if (performance.navigation.type === 1 && self.clearStorage === 1 && self.clear === true) {
                window.localStorage.clear();
            }
        };
        if(self.clearStorage === 1 && self.clear === true){
            window.localStorage.clear();
        }

        this.$root.$on('updateBalanceAfterAllocation', this.handleUpdateBalanceAfterAllocation);

        if(this.openModalOperationId == null || this.openModalOperationId == '' || this.openModalOperationId == undefined){
        }


        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('operation_id') && urlParams.get('status') === 'rejected'){
            self.destroyOperationAfterDocumentStatusChangeToRejected(urlParams.get('operation_id'));
        }
    },
    store
}
</script>

<style scoped>

</style>
